import { any } from 'lodash/fp';
import { createSelector } from 'reselect';
import { getProp } from '@mews/fp';
import { FeatureFlagService } from '@mews/framework';
import { getContainer } from '@mews-commander/legacy-app-instance';
import { getServiceOption } from '@mews-commander/legacy-entities/src/ducks/services';
import { getSelectedServices } from '../../../selectors';
import { APPLY_CANCELLATION_FEE, SEND_EMAIL_TO_CUSTOMER_AND_BOOKER } from './constants';
import { getCancellationReasonOptions as getCancellationReasonOptionsHelper } from './helpers';

export const getCancellationReasonOptions = createSelector(
    getProp<FeatureFlagService>()('featureFlagService'),
    getContainer,
    (featureFlagService, container) => {
        const { appLocalizationComponent } = container();

        return getCancellationReasonOptionsHelper({
            featureFlagService,
            localizeEnum: appLocalizationComponent.localizeEnumify,
        });
    }
);

export const getCancellationFormInitialValues = createSelector(getSelectedServices, (services) => ({
    [APPLY_CANCELLATION_FEE]: any(getServiceOption('applyCancellationFeeByDefault'))(services),
    [SEND_EMAIL_TO_CUSTOMER_AND_BOOKER]: any(getServiceOption('sendCancellationEmailByDefault'))(services),
}));
